import { Injector } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import {
  inputFieldParseIntoSettingsFormModel,
  inputFieldUpdateFromSettingsFormModel,
} from '../input-field-type.configuration';
import { BaseFormlyFieldConfiguration } from './base-formly-field-configuration';

export class InputFormlyFieldConfiguration extends BaseFormlyFieldConfiguration {
  constructor(injector: Injector, field: FormlyFieldConfig) {
    super(injector, field);

    if (field?.props?.type === 'number') {
      this.availableValidations.push('min', 'max');
    }

    if (!field?.props?.type) {
      this.availableValidations.push(
        'minLength',
        'maxLength',
        'patternValidation'
      );
      this.availableConditionalValidations.push(
        'minLength',
        'maxLength',
        'patternValidation'
      );
    }
  }

  override parseFieldConfigIntoSettingsFormModel() {
    return inputFieldParseIntoSettingsFormModel(this.field);
  }

  override updateFieldConfigFromSettingsFormModel(
    model: any
  ): FormlyFieldConfig {
    return inputFieldUpdateFromSettingsFormModel(model, this.field);
  }
}
